import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "../Button/Button";
import Popup from "../Popup/PopupManager";
import "./tabs.scss";

class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
    };

    this.handleTogglePopup = this.handleTogglePopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  closePopup() {
    this.setState({
      showPopup: false,
    });
  }

  handleTogglePopup() {
    const { showPopup } = this.state;
    this.setState({
      showPopup: !showPopup,
    });
  }

  render() {
    const { showPopup } = this.state;
    const { onTabLinkClick, tabs, noSelectedTabLabel, className, ...props } = this.props;
    const selectedTab = tabs.find(tab => tab.selected === true);

    const handleTabClick = tabId => {
      onTabLinkClick(tabId);
      this.closePopup();
    };

    return (
      <nav className={className} {...props}>
        <div className="tab-dropdown">
          <Button
            id="TabDropdownOpener"
            text={selectedTab ? selectedTab.label : noSelectedTabLabel}
            variant="link"
            onClick={this.handleTogglePopup}
            active={showPopup}
            className="tab-dropdown__button"
          />
          <Popup
            className="tab-dropdown__arrow"
            showPopup={showPopup}
            handleTogglePopup={this.handleTogglePopup}
            closePopup={this.closePopup}
            position="bottom"
          >
            <ul className="tab-dropdown__items">
              {tabs.map(tab => (
                <li className="tab-dropdown__item" key={tab.id}>
                  <Button
                    text={tab.label}
                    variant="nav"
                    onClick={() => {
                      handleTabClick(tab.id);
                    }}
                    className="tab-dropdown__link"
                    active={tab.selected}
                  />
                </li>
              ))}
            </ul>
          </Popup>
        </div>
        <div className="tab-bar">
          <ul className="tab-bar__items">
            {tabs.map(tab => (
              <li className="tab-bar__item" key={tab.id}>
                <Button
                  text={tab.label}
                  variant="nav"
                  onClick={() => {
                    handleTabClick(tab.id);
                  }}
                  className="tab-bar__link"
                  active={tab.selected}
                />
              </li>
            ))}
          </ul>
        </div>
      </nav>
    );
  }
}

Tabs.defaultProps = {
  noSelectedTabLabel: "Select...",
  className: "",
};

Tabs.propTypes = {
  className: PropTypes.string,
  onTabLinkClick: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.bool.isRequired]),
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  noSelectedTabLabel: PropTypes.string,
};

export default Tabs;
